/**
 * Gestion des indices et mots-clés saisis dans le formulaire d'exercice.
 */

import { useState } from 'react';
import { ExerciseFormData } from './types';

/** États de saisie et handlers d'ajout/suppression des indices et mots-clés. */
export const useTagListEditors = (
  formData: ExerciseFormData,
  setFormData: (data: ExerciseFormData) => void
) => {
  // États pour hints et keywords
  const [newHint, setNewHint] = useState('');
  const [newKeyword, setNewKeyword] = useState('');

  // Hints management
  const handleAddHint = () => {
    if (newHint.trim()) {
      const hints = [...(formData.hints || []), newHint.trim()];
      setFormData({ ...formData, hints });
      setNewHint('');
    }
  };

  const handleRemoveHint = (index: number) => {
    const hints = [...(formData.hints || [])];
    hints.splice(index, 1);
    setFormData({ ...formData, hints });
  };

  // Keywords management
  const handleAddKeyword = () => {
    if (newKeyword.trim()) {
      const keywords = [...(formData.keywords || []), newKeyword.trim()];
      setFormData({ ...formData, keywords });
      setNewKeyword('');
    }
  };

  const handleRemoveKeyword = (index: number) => {
    const keywords = [...(formData.keywords || [])];
    keywords.splice(index, 1);
    setFormData({ ...formData, keywords });
  };

  return {
    newHint, setNewHint, handleAddHint, handleRemoveHint,
    newKeyword, setNewKeyword, handleAddKeyword, handleRemoveKeyword,
  };
};

/** Valeurs et handlers renvoyés par useTagListEditors. */
export type TagListEditors = ReturnType<typeof useTagListEditors>;
